import type { ReactNode } from 'react'
import {
  ModalSheet,
  ModalSheetContent,
  ModalSheetContentTitle,
  ModalSheetFooter,
  ModalSheetFooterButtonGroup,
  ModalSheetFooterSpacer,
  ModalSheetHeader,
  ModalSheetSection,
} from '@/components/ModalSheet'
import { Button } from '@/components/Button'

export interface AddClientDialogProps {
  showing: boolean
  onClose: () => unknown
  isPending: boolean
  formId: string
  /**
   * The form, which must use `formId` so the footer button submits it.
   */
  children?: ReactNode
}

export function AddClientDialog({
  showing,
  onClose,
  isPending,
  formId,
  children,
}: AddClientDialogProps) {
  return (
    <ModalSheet
      showing={showing}
      onRequestClose={isPending ? undefined : onClose}
    >
      <ModalSheetHeader withCloseButton />
      <ModalSheetContent>
        <ModalSheetSection spaced>
          <ModalSheetContentTitle>Create client</ModalSheetContentTitle>
          {children}
        </ModalSheetSection>
      </ModalSheetContent>
      <ModalSheetFooter>
        <ModalSheetFooterSpacer />
        <ModalSheetFooterButtonGroup>
          <Button
            label="Cancel"
            variant="default"
            isDisabled={isPending}
            onPress={onClose}
          />
          <Button
            label="Create client"
            variant="primary"
            type="submit"
            form={formId}
            isPending={isPending}
            isDisabled={isPending}
          />
        </ModalSheetFooterButtonGroup>
      </ModalSheetFooter>
    </ModalSheet>
  )
}
